import { Trash } from 'lucide-react'
import type { ChangeEvent } from 'react'
import { ToggleSwitch } from 'src/modules/core/components'
import type { QuestionCardFooterProps } from './question-card-footer.interface'
import classes from './question-card-footer.module.scss'

export function QuestionCardFooter({
  requiredId,
  required,
  confirmLabel,
  onRequiredChange,
  onConfirm,
  onCancel,
  onDelete,
}: QuestionCardFooterProps) {
  return (
    <div className={classes.root}>
      <div className={classes.required}>
        <ToggleSwitch
          id={requiredId}
          checked={required}
          onChange={(event: ChangeEvent<HTMLInputElement>) => onRequiredChange(event.target.checked)}
        />
        <label htmlFor={requiredId}>Required</label>
      </div>
      <div className={classes.buttons}>
        {onDelete && (
          <button type="button" className={classes.iconButton} aria-label="Delete question" onClick={onDelete}>
            <Trash size={18} aria-hidden="true" />
          </button>
        )}
        <button type="button" className={classes.textButton} onClick={onCancel}>
          Cancel
        </button>
        <button type="button" className={classes.primaryButton} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </div>
  )
}
